<div mat-dialog-title>
    Reminders
</div>
<div>
    <mat-tab-group class="c-tab-group" animationDuration="0ms" disablePagination="true"
                   [(selectedIndex)]="selectedReminderTabIndex">
        <mat-tab>
            <ng-template mat-tab-label>
                Past
            </ng-template>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Today's
            </ng-template>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Future
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>

<mat-dialog-content>
    <div *ngIf="selectedReminderTabIndex == ReminderTabIndex.TODAY">
        <div *ngIf="todayReminders.length > 0; else noTodayReminder" class="d-flex flex-column gap-2">
            <div *ngFor="let reminder of todayReminders">
                <app-dash-reminder-card
                        [reminderData]="reminder"
                        (viewReminderEvent)="viewReminderEvent($event, ReminderTabIndex.TODAY)"
                        (markAsDoneEvent)="markAsDoneEvent($event, ReminderTabIndex.TODAY)">
                </app-dash-reminder-card>
            </div>
        </div>
        <ng-template #noTodayReminder>
            <div class="alert alert-info  custom-color">
                You don't have any upcoming reminders
            </div>
        </ng-template>

    </div>

    <div *ngIf="selectedReminderTabIndex == ReminderTabIndex.FUTURE">
        <div *ngIf="futureReminders.length >0; else noFutureReminder" class="d-flex flex-column gap-2">
            <div *ngFor="let reminder of futureReminders">
                <app-dash-reminder-card
                        [reminderData]="reminder"
                        (viewReminderEvent)="viewReminderEvent($event, ReminderTabIndex.FUTURE)"
                        (markAsDoneEvent)="markAsDoneEvent($event, ReminderTabIndex.FUTURE)">
                </app-dash-reminder-card>
            </div>
        </div>

        <ng-template #noFutureReminder>
            <div class="alert alert-info  custom-color">
                You don't have any upcoming reminders
            </div>
        </ng-template>
    </div>

    <div *ngIf="selectedReminderTabIndex == ReminderTabIndex.PAST">
        <div *ngIf="pastReminders.length > 0; else noOldReminders" class="d-flex flex-column gap-2">
            <div *ngFor="let reminder of pastReminders">
                <app-dash-reminder-card
                        [reminderData]="reminder"
                        (viewReminderEvent)="viewReminderEvent($event, ReminderTabIndex.PAST)"
                        (markAsDoneEvent)="markAsDoneEvent($event, ReminderTabIndex.PAST)">
                </app-dash-reminder-card>
            </div>
        </div>
        <ng-template #noOldReminders>
            <div class="alert alert-info  custom-color">
                No Past Reminders
            </div>
        </ng-template>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="reminder-control-btn">
    <button mat-button class="add-reminder" (click)="addNewReminder()">
        <mat-icon [svgIcon]="'plus-icon'" class="plus mat-icon-sm"></mat-icon>
        <span class="ff-medium">Add Reminder</span>
    </button>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>